// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__lXA08","file":"styles_file__2TXmy"};